import { render, staticRenderFns } from "./FormChoiceQuestion.vue?vue&type=template&id=5d326498&scoped=true"
import script from "./FormChoiceQuestion.vue?vue&type=script&lang=js"
export * from "./FormChoiceQuestion.vue?vue&type=script&lang=js"
import style0 from "./FormChoiceQuestion.vue?vue&type=style&index=0&id=5d326498&prod&lang=scss&scoped=true"
import style1 from "./FormChoiceQuestion.vue?vue&type=style&index=1&id=5d326498&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d326498",
  null
  
)

export default component.exports